import { css, cx } from "@emotion/css";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { DeploymentFreezeSummary, DeploymentFreezeListPage } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { ProjectChip, TenantChip } from "~/components/Chips/index";
import { DataTableRowColumn } from "~/primitiveComponents/dataDisplay/DataTable/index";
interface DeploymentFreezeDataTableScopesCellProps {
    freeze: DeploymentFreezeSummary;
    freezeListPage: DeploymentFreezeListPage;
    showTenantScope?: boolean;
}
export const DeploymentFreezeDataTableScopesCell = ({ freeze, freezeListPage, showTenantScope }: DeploymentFreezeDataTableScopesCellProps) => {
    const tenants = freeze.Tenants;
    const projects = freeze.Projects;
    const hasTenants = tenants.Items.length > 0;
    const hasProjects = projects.Items.length > 0;
    const isProjectFreezeListPage = freezeListPage === "project";
    if (!hasTenants && !hasProjects) {
        return (<DataTableRowColumn className={cx(cellStyles, "freeze-scope-cell")}>
                <div className={noScopesStyles}>No scopes</div>
            </DataTableRowColumn>);
    }
    return (<DataTableRowColumn className={cx(cellStyles, "freeze-scope-cell")}>
            <div className={scopesContainerStyles}>
                {!isProjectFreezeListPage && hasProjects && (<div className={cx(scopeLineStyles, showTenantScope && hasTenants && projectScopeLineStyles)}>
                        {hasProjects && (projects.Items.length === 1 ? <ProjectChip projectName={projects.Items[0].Name}/> : <ProjectChip projectName={`${projects.Items.length + (projects.MoreItems || 0)} projects`} noTooltip={true}/>)}
                    </div>)}
                {isProjectFreezeListPage && (<div className={cx(scopeLineStyles, showTenantScope && hasTenants && projectScopeLineStyles)}>
                        <div className={emptyProjectScopeStyles}></div>
                    </div>)}
                {hasTenants && showTenantScope && (<div className={scopeLineStyles}>
                        {hasTenants &&
                (tenants.Items.length === 1 ? (<TenantChip tenantName={tenants.Items[0].Name} isDisabled={tenants.Items[0].IsDisabled}/>) : (<TenantChip tenantName={`${tenants.Items.length + (tenants.MoreItems || 0)} tenants`} noTooltip={true}/>))}
                    </div>)}
            </div>
        </DataTableRowColumn>);
};
const noScopesStyles = css({
    margin: space[4],
});
const cellStyles = css({ width: "15%" });
const scopesContainerStyles = css({
    display: "flex",
    flexDirection: "column",
    gap: space[4],
});
const scopeLineStyles = css({
    display: "flex",
    alignItems: "center",
});
const emptyProjectScopeStyles = css({
    minHeight: "2rem",
    display: "flex",
    alignItems: "center",
});
const projectScopeLineStyles = css({
    borderBottom: `1px solid ${themeTokens.color.border.primary}`,
    marginBottom: space[4],
    paddingBottom: space[8],
});
